/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactWithRelations } from '../../models/contact-with-relations';

export interface EditorCreateContact$Params {
      body?: ContactWithRelations
}

export function editorCreateContact(http: HttpClient, rootUrl: string, params?: EditorCreateContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactWithRelations>> {
  const rb = new RequestBuilder(rootUrl, editorCreateContact.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactWithRelations>;
    })
  );
}

editorCreateContact.PATH = '/editor/contacts';
